import { BCMSCurrency, BCMSDate, useWorkflowStep } from "@bcm-dev/bcms-vite";
import MultiPayItem from "compid/workflows/MultiPay/classes/MultiPayItem";
import { Bill, Biller, Payment } from "model";

import WidgetContainer from "compid/shared/containers/WidgetContainer";
import BillerInfoView from "compid/shared/views/BillerView/components/views/BillerInfoView";
import TableView, { TableRowView } from "compid/shared/views/TableView";
import { getDefaultMultiPay, getWorkflowSteps } from "compid/workflows/MultiPay";

export default function MultipayConfirmationWidget(props){
  const workflowStep = useWorkflowStep(getDefaultMultiPay, getWorkflowSteps);
  const multipay = props.multipay ?? MultiPayItem.init(Bill.firstInstanceOf());
  const amount = multipay.amount.format();
  const payFrom = `${ multipay.account.name } ${ multipay.account.number }`;
  const deliveryDate = multipay.formatDate();
  const isPaper = multipay.bill.biller.paymentType === "paper";
  const isElectronic = multipay.bill.biller.paymentType === "electronic";
  const isVirtualCard = multipay.bill.biller.paymentType === "virtualCard";
  const deliveryMethod = isPaper ? "Paper" : "Electronic";
  const biller = multipay.bill.biller;
  const billerAddress = biller.address;
  let billerCityState = `${ biller.city }, ${ biller.state }, ${ biller.zip }`;

  const paymentDate = multipay.date;
  const withdrawnOnDate = multipay.withdrawnOnDate;
  let withdrawnOnDateFormatted = withdrawnOnDate ? withdrawnOnDate.format("M d") : paymentDate.format("M d");
  const hasRealTimeGoodFunds = Payment.hasRealTimeGoodFunds(multipay.bill.biller.paymentType, workflowStep.model.branding);
  
  const feeAmount = multipay.feeAmount.format();
  const totalAmount = BCMSCurrency.init(parseFloat(multipay.amount.amount) + parseFloat(multipay.feeAmount.amount ?? "0"));

  const estimatedDeliveryMessage = `Your check may be cashed, and the money withdrawn from your account before, on, or after ${ deliveryDate }.`;
  const withdrawnOnView = <TableRowView rowClassName="withdraw-on-row" labelClass="semi-bold-text" label="Withdraw on" data={ withdrawnOnDateFormatted } dataPoint="Withdraw_On_Date" />;
  const withdrawOnFinePrint = `If funds are not available on that date, the payment will fail.`;
  let showWithdrawnOnView = false;
  let showWithdrawnOnFinePrintView = false;

  // Block for determining when the withdraw fine print message is shown.
  if(isElectronic && hasRealTimeGoodFunds) {
      showWithdrawnOnView = true;
      const todaysDate = BCMSDate.init();

      // Show the withdraw fine print if the withdraw date is not immediate.
      if(withdrawnOnDate.isAfter(todaysDate)) {
          showWithdrawnOnFinePrintView = true;
      }
  }
  
  const withdrawOnFinePrintView = <TableRowView label="" labelClass="semi-bold-text" data={ withdrawOnFinePrint } dataClass="fine-print" />;

  return(
    <WidgetContainer className="multipay-confirmation-widget">
      <div className="multipay-biller-container">
        <BillerInfoView biller={ multipay.bill.biller } />

        <TableView>
          <TableRowView label="Confirmation" labelClass="semi-bold-text" data="12345-ABCDE" />

          { !multipay._hasFee && <TableRowView label="Amount" labelClass="semi-bold-text" data={amount} /> }

          { multipay._hasFee &&
            <>  
                <TableRowView label="Amount" rowClassName="has-fee-row" data={amount} />
                <TableRowView label="Delivery fee" rowClassName="has-fee-row" data={ feeAmount } />
                <TableRowView label="Total amount" labelClass="semi-bold-text" dataClass="semi-bold-text" rowClassName="has-fee-row total-row" data={ totalAmount.format() } dataPoint="Payment_Confirmation_Total" />
            </> 
          }

          <TableRowView label="Pay from" labelClass="semi-bold-text" data={payFrom} />
          {/* For Paper Billers */}
          { isPaper && 
          <>
              <TableRowView label="Estimated delivery" labelClass="semi-bold-text" data={ deliveryDate } />
              { !hasRealTimeGoodFunds && <TableRowView label="" data={ estimatedDeliveryMessage } dataClass="fine-print" /> }
              { hasRealTimeGoodFunds && <TableRowView label="Withdraw on" labelClass="semi-bold-text" data={  withdrawnOnDateFormatted  } dataClass="fine-print" dataPoint="Fine_Print_Withdraw_On_Date" /> }
          </> 
          }

          {/* For electronic billers */}
          { !isPaper && <TableRowView label="Deliver by" labelClass="semi-bold-text" data={ deliveryDate } /> }
          
          { showWithdrawnOnView && withdrawnOnView }
          { showWithdrawnOnFinePrintView && withdrawOnFinePrintView }
          <TableRowView label="Delivery method" labelClass="semi-bold-text" data={ deliveryMethod } />

          {   (multipay._hasFee && isPaper) && 
          <TableRowView rowClassName="overnight-address" labelClass="semi-bold-text" label="Overnight address" data={<><p>{ billerAddress }</p><p>{ billerCityState }</p></>} />
           }

        </TableView>
        { isVirtualCard && <div>{ Biller.getVirtualCardDisclaimer() }</div> }
      </div>
    </WidgetContainer>
  );

}